/**
 * @desc 全局事件总线（基于 CustomEvent + EventTarget）
 */

type EventHandler = (data: any) => void;

class EventBus {
  private eventTarget: EventTarget = document.body;
  // 为了方便移除事件监听器
  private listenerMap = new WeakMap<EventHandler, EventListener>();

  on(eventName: string, handler: EventHandler) {
    const listener = (e: Event) => {
      handler((e as CustomEvent).detail);
    };
    this.listenerMap.set(handler, listener);
    this.eventTarget.addEventListener(eventName, listener);
    return () => this.off(eventName, handler);
  }

  off(eventName: string, handler: EventHandler) {
    const listener = this.listenerMap.get(handler);
    if (listener) {
      this.eventTarget.removeEventListener(eventName, listener);
      this.listenerMap.delete(handler);
    }
  }

  dispatch(eventName: string, data?: any) {
    const event = new CustomEvent(eventName, {
      detail: data,
    });
    this.eventTarget.dispatchEvent(event);
  }
}

export const eventBus = new EventBus();
